document.addEventListener("DOMContentLoaded", function () {
  const el = document.getElementById("cbd-calculator");
  if (!el) return;

  /* -----------------------------
     QUESTION DATA
  ----------------------------- */
  const questions = [
    {
      id: "weight",
      title: "What is your body weight?",
      subtitle: "Your weight helps us calculate the right dosage",
      options: [
        { value: "light", label: "Under 130 lbs (59 kg)", multiplier: 0.8 },
        { value: "medium", label: "130–230 lbs (59–104 kg)", multiplier: 1 },
        { value: "heavy", label: "Over 230 lbs (104 kg)", multiplier: 1.3 }
      ]
    },
    {
      id: "experience",
      title: "What is your CBD experience level?",
      subtitle: "This helps us recommend the right starting point",
      options: [
        { value: "beginner", label: "Beginner – New to CBD", multiplier: 0.7 },
        { value: "intermediate", label: "Intermediate – Used CBD before", multiplier: 1 },
        { value: "experienced", label: "Experienced – Regular CBD user", multiplier: 1.4 }
      ]
    },
    {
      id: "reason",
      title: "What is your primary reason for using CBD?",
      subtitle: "Different needs require different approaches",
      options: [
        { value: "wellness", label: "General Wellbeing & Balance", base: 15 },
        { value: "stress", label: "Stress & Anxiety Relief", base: 20 },
        { value: "sleep", label: "Sleep Support", base: 25 },
        { value: "pain", label: "Pain & Inflammation", base: 30 },
        { value: "recovery", label: "Post-Workout Recovery", base: 20 }
      ]
    },
    {
      id: "severity",
      title: "How would you rate the severity?",
      subtitle: "This helps us fine-tune your recommendation",
      options: [
        { value: "mild", label: "Mild – Occasional discomfort", multiplier: 0.8 },
        { value: "moderate", label: "Moderate – Regular issues", multiplier: 1 },
        { value: "severe", label: "Severe – Significant impact", multiplier: 1.3 }
      ]
    }
  ];

  let step = 0;
  let answers = { weight: "", experience: "", reason: "", severity: "" };
  let result = null;

  /* -----------------------------
     MAIN RENDER FUNCTION
  ----------------------------- */
  function render() {
    el.innerHTML = "";
    const container = document.createElement("div");
    container.className = "cbd-container";

    /* -----------------------------
       RESULTS SCREEN
    ----------------------------- */
    if (result) {
      const card = document.createElement("div");
      card.className = "cbd-card";

      /* Logo */
      const logo = document.createElement("img");
      logo.className = "cbd-logo";
      logo.src = "https://naturaleuphoria.co.uk/cdn/shop/files/natural-euphoria-logo_34d5a216-00ed-4e51-9e58-13b27e867819_500x@2x.png?v=1614313247";
      card.appendChild(logo);

      /* Checkmark Icon */
      const iconWrapper = document.createElement("div");
      iconWrapper.className = "cbd-check-icon";
      iconWrapper.innerHTML = `
        <div class="cbd-check-icon-inner">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              d="M5 13l4 4L19 7" />
          </svg>
        </div>
      `;
      card.appendChild(iconWrapper);

      /* Output Title */
      const title = document.createElement("h2");
      title.className = "cbd-main-title";
      title.textContent = "Your Personalised CBD Dosage";
      card.appendChild(title);

      /* Subtitle */
      const subtitle = document.createElement("div");
      subtitle.className = "cbd-subtitle-output";
      subtitle.textContent = `Based on your answers for ${result.reason}`;
      card.appendChild(subtitle);

      /* ---- DOSAGE BOX ---- */
      const dosage = document.createElement("div");
      dosage.className = "cbd-result-card";
      dosage.innerHTML = `
        <div class="cbd-result-big">${result.recommended} mg</div>
        <div class="cbd-result-sub">Recommended Daily Dosage</div>

        <div class="cbd-range-wrapper">
          <div class="cbd-range-number">${result.low} mg</div>

          <div class="cbd-range-bar">
            <div class="cbd-range-fill"></div>
          </div>

          <div class="cbd-range-number">${result.high} mg</div>
        </div>
      `;
      card.appendChild(dosage);

      /* ---- RECOMMENDED SPECTRUM ---- */
      const spectrum = document.createElement("div");
      spectrum.className = "cbd-spectrum-card";
      spectrum.innerHTML = `
        <h3 style="font-weight:700; font-size:1.2rem; margin-bottom:0.8rem;">
          🌿 Recommended CBD Spectrum
        </h3>

        <div class="cbd-spectrum-inner">
          <div class="cbd-spectrum-name">${result.spectrum} CBD</div>
        </div>

        <p style="font-size:0.95rem; margin-bottom:1rem;">
          ${result.spectrumReason}
        </p>
      `;

      /* CTA Button */
      const ctaWrapper = document.createElement("div");
      ctaWrapper.className = "cbd-cta-wrapper";

      const cta = document.createElement("a");
      cta.href = result.spectrumUrl;
      cta.className = "cbd-spectrum-btn";
      cta.textContent = `Shop ${result.spectrum} Oils →`;

      ctaWrapper.appendChild(cta);
      spectrum.appendChild(ctaWrapper);
      card.appendChild(spectrum);

      /* ---- HOW TO USE ---- */
      const how = document.createElement("div");
      how.className = "cbd-box-green";
      how.innerHTML = `
        <h4>💡 How to Use</h4>
        <p>Start with ${result.low}mg daily and gradually increase up to ${result.recommended}mg over 1–2 weeks.</p>
      `;
      card.appendChild(how);

      /* ---- IMPORTANT NOTE ---- */
      const note = document.createElement("div");
      note.className = "cbd-box-yellow";
      note.innerHTML = `
        <h4>⚠️ Important Note</h4>
        <p>This calculator provides guidance only. Consult a healthcare professional if you are on medication or have health conditions.</p>
      `;
      card.appendChild(note);

      /* ---- PRO TIPS ---- */
      const tips = document.createElement("div");
      tips.className = "cbd-protips";
      tips.innerHTML = `
        <h4>📝 Pro Tips</h4>
        <ul>
          <li>Track your dosage and effects in a journal.</li>
          <li>Wait 2–4 weeks before adjusting dosage.</li>
          <li>Take with food for better absorption.</li>
          <li>Stay hydrated throughout the day.</li>
        </ul>
      `;
      card.appendChild(tips);

      /* Restart Button */
      const restart = document.createElement("button");
      restart.className = "cbd-btn cbd-btn-primary";
      restart.textContent = "Start New Calculation";
      restart.onclick = () => {
        step = 0;
        answers = { weight: "", experience: "", reason: "", severity: "" };
        result = null;
        render();
      };
      card.appendChild(restart);

      /* Disclaimer */
      const disc = document.createElement("p");
      disc.className = "cbd-disclaimer";
      disc.textContent = "This calculator is for informational purposes only and does not constitute medical advice.";
      card.appendChild(disc);

      container.appendChild(card);
      el.appendChild(container);
      return;
    }

    /* -----------------------------
       QUESTION SCREEN
    ----------------------------- */
    const card = document.createElement("div");
    card.className = "cbd-card";

    /* Badge */
    const badge = document.createElement("div");
    badge.className = "cbd-time-badge";
    badge.textContent = "⏱ Takes less than 60 seconds";
    card.appendChild(badge);

    /* Title */
    const title = document.createElement("h2");
    title.className = "cbd-main-title";
    title.textContent = "Find Your Perfect CBD Dosage";
    card.appendChild(title);

    /* Progress Row */
    const progress = document.createElement("div");
    progress.className = "cbd-progress-row";
    progress.innerHTML = `
      <div class="cbd-progress-left">Question ${step + 1} of ${questions.length}</div>
      <div class="cbd-progress-right">${Math.round(((step + 1) / questions.length) * 100)}%</div>
    `;
    card.appendChild(progress);

    /* Progress Bar */
    const bar = document.createElement("div");
    bar.className = "cbd-progress-bar";

    const fill = document.createElement("div");
    fill.className = "cbd-progress-fill";
    fill.style.width = `${((step + 1) / questions.length) * 100}%`;

    bar.appendChild(fill);
    card.appendChild(bar);

    /* Question Title + Subtitle */
    const q = questions[step];

    const qTitle = document.createElement("div");
    qTitle.className = "cbd-title";
    qTitle.textContent = q.title;
    card.appendChild(qTitle);

    const qSub = document.createElement("p");
    qSub.className = "cbd-sub";
    qSub.textContent = q.subtitle;
    card.appendChild(qSub);

    /* Options */
    q.options.forEach(opt => {
      const btn = document.createElement("button");
      btn.className = "cbd-option";
      btn.textContent = opt.label;

      if (answers[q.id] === opt.value) {
        btn.classList.add("cbd-option-active");
      }

      btn.onclick = () => {
        answers[q.id] = opt.value;
        render();
      };

      card.appendChild(btn);
    });

    /* Continue Button */
    const next = document.createElement("button");
    next.className = answers[q.id] ? "cbd-btn cbd-btn-primary" : "cbd-btn cbd-btn-disabled";
    next.textContent = step === questions.length - 1 ? "Get My Dosage →" : "Continue →";

    next.onclick = () => {
      if (!answers[q.id]) return;

      if (step < questions.length - 1) {
        step++;
        render();
      } else {
        calculateResult();
      }
    };

    card.appendChild(next);

    /* Disclaimer */
    const disc = document.createElement("p");
    disc.className = "cbd-disclaimer";
    disc.textContent = "This calculator is for informational purposes only and does not constitute medical advice.";
    card.appendChild(disc);

    container.appendChild(card);
    el.appendChild(container);
  }

  /* -----------------------------
     CALCULATE DOSAGE
  ----------------------------- */
  function calculateResult() {
    const weightMult = questions[0].options.find(o => o.value === answers.weight)?.multiplier || 1;
    const expMult = questions[1].options.find(o => o.value === answers.experience)?.multiplier || 1;
    const base = questions[2].options.find(o => o.value === answers.reason)?.base || 20;
    const sevMult = questions[3].options.find(o => o.value === answers.severity)?.multiplier || 1;

    const low = Math.round(base * weightMult * expMult * sevMult * 0.8);
    const high = Math.round(base * weightMult * expMult * sevMult * 1.2);
    const recommended = Math.round((low + high) / 2);

    const reasonLabels = {
      wellness: "General Wellbeing",
      stress: "Stress & Anxiety",
      sleep: "Sleep Support",
      pain: "Pain Relief",
      recovery: "Recovery"
    };

    let spectrum = "Broad-Spectrum";
    let description = "Broad-Spectrum CBD delivers the entourage effect while remaining THC-free.";
    let url = "/collections/broad-spectrum-cbd-oil";

    if (answers.experience === "beginner") {
      spectrum = "Isolate";
      description = "Isolate CBD is ideal for beginners. Pure CBD with no additional cannabinoids.";
      url = "/collections/isolate-cbd-oil";
    }

    if (answers.experience === "experienced" && (answers.reason === "pain" || answers.severity === "severe")) {
      spectrum = "Full-Spectrum";
      description = "Full-Spectrum CBD offers the strongest entourage effect for deeper relief.";
      url = "/collections/full-spectrum-cbd-oil";
    }

    result = {
      low,
      high,
      recommended,
      reason: reasonLabels[answers.reason],
      spectrum,
      spectrumReason: description,
      spectrumUrl: url
    };

    render();
  }

  render();
});
